module.exports = __webpack_public_path__ + "static/media/image.c587573b.svg";